<template>
  <div class="Sidebar">
    <div class="Sidebar-logo">
      <img src="@/assets/noscope360-logo.svg" alt="" />
    </div>
    <div class="Sidebar-links">
      <router-link
        active-class="is-active"
        :to="{ name: 'ProspectingReport', params: { days: 7 } }"
      >
        <span>Benchmarking Report</span>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "Sidebar",
  setup() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
.Sidebar {
  color: #222;
  font-size: 14px;
  &-logo {
    background-color: #000;
    line-height: 66px;
    text-align: center;
    border-bottom: 1px solid rgba(255, 255, 255, 0.15);
    > img {
      width: auto;
      height: 20px;
      vertical-align: middle;
    }
  }
  &-links {
    flex-grow: 1;
    padding: 20px 0;
    hr {
      border: 0;
      border-top: 1px solid rgba(255, 255, 255, 0);
      background-color: transparent;
      margin: 0;
    }
    a {
      display: block;
      line-height: 56px;
      padding: 0 24px;
      text-decoration: none;
      color: rgba(255, 255, 255, 0.7);
      font-size: 14px;
      transition: background-color 0.2s, padding 0.2s;
      background-color: rgba(255, 255, 255, 0);
      border-left: 0px solid #fff;
      font-weight: 400;
      text-transform: uppercase;
      letter-spacing: 1px;
      span {
        background-color: rgba(255, 255, 255, 0);
        border: 1px solid rgba(255, 255, 255, 0);
        transition: border 0.2s, box-shadow 0.2s 0.1s, margin-left 0.2s 0.1s;
        display: inline-block;
        line-height: 28px;
        padding: 0 8px;
        box-shadow: 0px 0px 0 0 rgba(255, 255, 255, 1);
      }
      &:hover {
        color: #fff;
        > svg {
          opacity: 0.6;
        }
      }
      &:active {
        transform: translateY(1px);
      }
      &.is-active {
        color: #fff;
        span {
          border: 1px solid rgba(255, 255, 255, 1);
          box-shadow: 3px 3px 0 0 rgba(255, 255, 255, 1);
          margin-left: -3px;
        }
      }
    }
    .submenu {
      > a {
        line-height: 44px;
        border: 0;
        padding-left: 36px;
        > svg {
          font-size: 7px;
          margin-bottom: 3px;
          display: inline-block;
          opacity: 0.15;
        }
      }
    }
  }
  &-usermenu {
    border-bottom: 1px solid #181e2c;
  }
}
</style>
